import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { TemplateSubmissionFields } from 'components/ReviewTemplateFormModal/Types'
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query'
import { ReviewTemplate } from 'types'
import { reviewTemplateKeys } from './reviewTemplateKeys'

export interface UseUpdateReviewTemplateProps
  extends UseMutationOptions<ReviewTemplate, unknown, TemplateSubmissionFields> {
  workspaceId: number
  templateId: number
}

interface UpdateReviewTemplateResponse {
  review_template: ReviewTemplate
}

export const useUpdateReviewTemplate = ({ workspaceId, templateId, ...options }: UseUpdateReviewTemplateProps) => {
  const client = useQueryClient()
  const onSuccess = (template: ReviewTemplate, variables: TemplateSubmissionFields, context: unknown) => {
    client.invalidateQueries(reviewTemplateKeys.list(workspaceId))
    options.onSuccess?.(template, variables, context)
  }
  return useMutation<ReviewTemplate, unknown, TemplateSubmissionFields>(
    async (fields: TemplateSubmissionFields) => {
      const res = await sendToApi<UpdateReviewTemplateResponse>(`/w/${workspaceId}/review_templates/${templateId}`, {
        method: 'PUT',
        body: fields,
      })
      if (res.type !== SUCCESS_RESPONSE_TYPE) throw new Error()
      return res.data.review_template
    },
    { ...options, onSuccess },
  )
}
